/** 
*@author: Sirisha.M
*@Description : 
**/
import React, { Fragment, useState, useEffect, useRef } from 'react';
import { constant } from '../Utils/constants';
import { Form, message, Upload, Tabs } from 'antd';
import localStorage from '../../../utils/localStorage';
import { IPAddress, UPLOAD } from '../../../commons/api';
import { DownloadOutlined, UploadOutlined } from '@ant-design/icons';
import themeSettings from '../../../commons/styles/themeSettings.json';
import { getAssetFileDownloadName, getCarandDeviceFileDownloadName, getParameterFileDownloadName } from '../APICalls';

const { TabPane } = Tabs;


const UploadAssets = (props) => {
  // const [formObject, setFormObject] = useState({});
  const [fileAssetDownloadName, setFileAssetDownloadName] = useState('');
  const [fileParameterDownloadName, setFileParameterDownloadName] = useState('');
  const [carAndAssetDownloadName, setCarAndAssetDownloadName] = useState('');
  const hRef = useRef();

  const { ShowForm, selectedRow, parent, translationCache } = props;
  let path = window.location.pathname.split('/rubus/CustomerAssetDeviceConfiguration/');
  const Module = path[1];
  // Fetch data when the component mounts or when props change
  useEffect(() => {
    setData(ShowForm);
  }, [ShowForm, selectedRow]);
  // Helper function to fetch data based on ShowForm
  const setData = async (ShowForm) => {
    if (ShowForm === 'UPLOAD_ASSETS') {
      getfileAssetDownloadName();
      getfileParamDownloadName();
      if (selectedRow && selectedRow.Type === 'Asset' && parent.Type === 'Module') {
        getfileAssetDownloadNameforCarandDevice();
      }
    }
  };

  // Translation function
  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  // Fetch file download name for assets
  const getfileAssetDownloadName = async () => {
    let parentAsset = selectedRow?.Type === 'Module' ? null : selectedRow.Code;
    let fileAssetDownloadNameResponse = await getAssetFileDownloadName(Module, parentAsset);
    setFileAssetDownloadName(fileAssetDownloadNameResponse?.file || '');
  };

  // Fetch file download name for car and device assets
  const getfileAssetDownloadNameforCarandDevice = async () => {
    let parentAsset = selectedRow?.Type === 'Module' ? null : selectedRow.Code;
    let carAndDeviceFileResponse = await getCarandDeviceFileDownloadName(Module, parentAsset);
    setCarAndAssetDownloadName(carAndDeviceFileResponse?.file || '');
  };
  const getfileParamDownloadName = async () => {
    let fileParameterDownloadName = await getParameterFileDownloadName(
      Module,
      selectedRow.Code
    );
    setFileParameterDownloadName(fileParameterDownloadName && fileParameterDownloadName.file ? fileParameterDownloadName.file : '');

  };
  // Render logic
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  const Authorization = `Bearer ${token}`;
  let parentAsset = selectedRow?.Type === 'Module' ? null : selectedRow.Code;
  return (
    <Fragment>
      <div
        style={{
          color: 'white',
          
          fontWeight: 'bold',
          display: 'flex',
          justifyContent: 'center',
          marginBottom: '24px',
        }}
      >
        {`Bulk upload for ${selectedRow.Name}`}
      </div>

      <Form
        name="Item"
        ref={hRef}
        theme={themeSettings}
        layout="horizontal"
        labelCol={{ flex: '130px', marginTop: '20px' }}
        labelAlign="right"
        labelWrap
      >
        <Tabs tabPosition="top" centered style={{ marginTop: '20px', marginBottom: '30px' }} theme={themeSettings}>
          {/* Bulk Upload Tab */}
          <TabPane tab="Bulk Upload Assets" key="1">
            <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '10px' }}>
              <Form.Item
                name="Download Assets"
                style={{ width: '50%' }}
                label={translation(constant.DownloadAssets)}
              >
                <a href={`${IPAddress.LOCAL}${fileAssetDownloadName}`}>
                  <DownloadOutlined style={{ color: 'white', marginRight: '1px' }} />
                  <span style={{ color: 'white' }}>Download</span>
                </a>
              </Form.Item>

              <Form.Item
                name="Upload Assets"
                style={{ width: '50%' }}
                label={translation(constant.UploadAssets)}
              >
                <Upload
                  multiple={false}
                  style={{ marginRight: '10px', color: 'white' }}
                  onChange={(info) => {
                    if (info.file.status === 'done') {
                      message.success(info.file.response.message);
                      getfileAssetDownloadName();
                      props.GetHierarchyLevelsUpdated();
                    } else if (info.file.status === 'error') {
                      message.error(info.file.response.message);
                    }
                  }}
                  action={`${UPLOAD.CLIENT_Upload_Asset}?SiteId=${siteId}&AssetType=asset&ModuleCode=${props.Module}&ParentAsset=${parentAsset}`}
                  headers={{
                    Authorization,
                  }}
                  showUploadList={false}
                >
                  <UploadOutlined style={{ color: 'white', marginRight: '1px' }} />
                  <span style={{ color: 'white', marginRight: '10px' }}> Upload</span>
                </Upload>
              </Form.Item>
            </div>
          </TabPane>
          <TabPane tab="Bulk Upload Parameters" key="2" style={{ color: 'white' }}>
            <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '10px' }}>
              <Form.Item
                name="Download Parameters"
                style={{ width: '50%' }}
                label={translation(constant.DownloadAssets)}
              >
                <a href={`${IPAddress.LOCAL}${fileParameterDownloadName}`}>
                  <DownloadOutlined
                    style={{ color: 'white', marginRight: '1px' }}
                  />
                  <span style={{ color: 'white' }}>Download</span>
                </a>
              </Form.Item>

              <Form.Item
                name="Upload Parameters"
                style={{ width: '50%' }}
                label={translation(constant.UploadAssets)}
              >
                <Upload
                  multiple={false}
                  style={{ marginRight: '10px', color: 'white' }}
                  onChange={(info) => {
                    if (info.file.status === 'done') {
                      message.success(info.file.response.message);
                      getfileParamDownloadName();
                      props.GetHierarchyLevelsUpdated();
                    } else if (info.file.status === 'error') {
                      message.error(info.file.response.message);
                    }
                  }}
                  action={`/api/client/upload/parameterBulk?SiteId=${siteId}&AssetCode=${selectedRow?.Code}&ModuleCode=${props.Module}`}
                  headers={{
                    Authorization: Authorization
                  }}
                  showUploadList={false}
                >
                  <UploadOutlined
                    style={{ color: 'white', marginRight: '1px' }}
                  />
                  <span style={{ color: 'white', marginRight: '10px' }}> Upload</span>
                </Upload>
              </Form.Item>
            </div>
          </TabPane>
          {/* Bulk Upload Along Devices Tab */}
          {selectedRow?.Type === 'Asset' && parent?.Type === 'Module' && (
            <TabPane tab="Bulk upload along devices" key="bulkUpload">
              <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '10px' }}>
                <Form.Item
                  name="Download"
                  style={{ width: '50%' }}
                  label={translation(constant.Download)}
                >
                  <a href={`${IPAddress.LOCAL}${carAndAssetDownloadName}`}>
                    <DownloadOutlined style={{ color: 'white', marginRight: '1px' }} />
                    <span style={{ color: 'white' }}>Download</span>
                  </a>
                </Form.Item>

                <Form.Item
                  name="Upload"
                  style={{ width: '50%' }}
                  label={translation(constant.Upload)}
                >
                  <Upload
                    multiple={false}
                    style={{ marginRight: '10px', color: 'white' }}
                    onChange={(info) => {
                      if (info.file.status === 'done') {
                        message.success(info.file.response.message);
                        getfileAssetDownloadNameforCarandDevice();
                        props.GetHierarchyLevelsUpdated();
                      } else if (info.file.status === 'error') {
                        message.error(info.file.response.message);
                      }
                    }}
                    action={`${UPLOAD.CLIENT_Upload_AssetBulk}?SiteId=${siteId}&AssetType=asset&ModuleCode=${props.Module}&ParentAsset=${parentAsset}`}
                    headers={{
                      Authorization,
                    }}
                    showUploadList={false}
                  >
                    <UploadOutlined style={{ color: 'white', marginRight: '1px' }} />
                    <span style={{ color: 'white', marginRight: '10px' }}> Upload</span>
                  </Upload>
                </Form.Item>
              </div>
            </TabPane>
          )}
        </Tabs>
      </Form>
    </Fragment>
  );
};

export default UploadAssets;

